import { render, staticRenderFns } from "./Imports_configuration.vue?vue&type=template&id=28b263a3&lang=pug&"
import script from "./Imports_configuration.vue?vue&type=script&lang=coffee&"
export * from "./Imports_configuration.vue?vue&type=script&lang=coffee&"
import style0 from "./Imports_configuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports